import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config, ApiVisa, 
         Pagination, PagingResponseModel, BasicApiResponseModel, ApiResponseModel } from '../shared';
import { OrgChartHierarchyNodeHdrContainerModel } from '../../../../../models/aggregates/hr';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrgChartHierarchyNodeHdrService extends BaseApiTemplateService<OrgChartHierarchyNodeHdrContainerModel> {

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HR_PREFIX + 'org-charts/hierarchy-node-hdrs';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HR_PREFIX + 'org-charts/hierarchy-node-hdrs';
        this.httpClient = http;
    }

    public get(visa: ApiVisa): Observable<ApiResponseModel<any>> {
        if (this.endpoint_path && visa.api_domain_url) {
          this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        return this.httpClient.get<ApiResponseModel<any>>(
          this.apiUrl + '/recursion/backoffice-ep',
          this.getHttpHeader(visa)
        );
    }

    public getByOrgChart(guid: string, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
        if (this.endpoint_path && visa.api_domain_url) {
          this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        return this.httpClient.get<BasicApiResponseModel<any>>(
          this.apiUrl + '/recursion/backoffice-ep/' + guid,
          this.getHttpHeader(visa)
        );
    }

    public getByGuid(guid: string, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
        if (this.endpoint_path && visa.api_domain_url) {
          this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        return this.httpClient.get<BasicApiResponseModel<any>>(
          this.apiUrl + '/backoffice-ep/' + guid,
          this.getHttpHeader(visa)
        );
    }
    
    public getByCriteria(pagination: Pagination, visa: ApiVisa, criteria?: any): Observable<PagingResponseModel<any>> {
        if (this.endpoint_path && visa.api_domain_url) {
            this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        const UrlByCriteria =
            this.apiUrl + '/backoffice-ep/query?' + pagination.getQueryKeyValues();
        return this.httpClient.get<PagingResponseModel<any>>(
            UrlByCriteria,
            this.getHttpHeader(visa)
        );
    }

    public getByCriteriaPost(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
        let url;
        if (this.endpoint_path && visa.api_domain_url) {
          url = visa.api_domain_url + this.endpoint_path + '/query';
        }
        return this.httpClient.post<ApiResponseModel<any>>(
          url,
          dtoObject,
          this.getHttpHeader(visa)
        );
      }

    public delete(guid: string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
        if (this.endpoint_path && visa.api_domain_url) {
            this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        return this.httpClient.delete<ApiResponseModel<any>>(
            this.apiUrl + '/recursion/backoffice-ep/' + guid,
            this.getHttpHeader(visa)
        );
    }

    public put(dtoObject: any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
        if (this.endpoint_path && visa.api_domain_url) {
            this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        return this.httpClient.put<BasicApiResponseModel<any>>(
            this.apiUrl + '/backoffice-ep',
            dtoObject,
            this.getHttpHeader(visa)
        );
    }

    public post(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
        if (this.endpoint_path && visa.api_domain_url) {
            this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        return this.httpClient.post<ApiResponseModel<any>>(
            this.apiUrl + '/backoffice-ep',
            dtoObject,
            this.getHttpHeader(visa)
        );
    }

    public generateOrgChart(employee_hdr_guids: string, visa: ApiVisa): Observable<any> {

      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path
      }
  
      const body = {
        employee_hdr_guids: [employee_hdr_guids],
      };
      return this.httpClient.post<ApiResponseModel<any>>(this.apiUrl + '/query', body, this.getHttpHeader(visa));      
    }
}